/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceBatchResponse {
    getFixupPrototypeFunction() { return ServiceResourceBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceBatchResponse>): ServiceResourceBatchResponse {
        let obj = Object.assign(new ServiceResourceBatchResponse(), model);
        ServiceResourceBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceBatchResponse>): ServiceResourceBatchResponse {
        if (!model) return null;
        return ServiceResourceBatchResponse.newInstance(<ServiceResourceBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceBatchResponse) {
        if (!obj) return;

        models.ServiceResourceBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceBatchResponse): boolean {
        Object.setPrototypeOf(obj, ServiceResourceBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ServiceResourceDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ServiceResourceDetails; };

}
